import React, { useState, useEffect } from 'react';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import { dtToDMY, dmyToDate } from 'common/functions/dateUtil';
import Header from 'common/js/header/header';
import DatePicker from 'react-datepicker';
import 'common/css/master.css';
import SubstitutionDutyTbl from './sustituionDutyTbl';
import { getSubstitutionDutiesSvc, getMonthlySubstitutionDutiesSvc, getYearlySubstitutionDutiesSvc, getAcademicYearListSvc } from './substitutionDutySvc';

const tabs = [
    { id: 'daily', label: 'Daily' },
    { id: 'monthly', label: 'Monthly' },
    { id: 'yearly', label: 'Yearly' },
];
const SubstitutionDutyCtrl = () => {
    const [activeTab, setActiveTab] = useState('daily');
    const [fromDt, setFromDt] = useState("");
    const [toDt, setToDt] = useState("");
    const [lstTchSubsDuty, setLstTchSubsDuty] = useState([]);
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [flgDutiesPopup, setFlgDutiesPopup] = useState(false);
    const [tchId, setTchId] = useState(0);
    const [substitutionDt, setSubstitutionDt] = useState("");
    const [monthInt, setMonthInt] = useState()
    const [month, setMonth] = useState()
    const [dt, setDt] = useState()
    const [year, setYear] = useState()
    const lstMonth = ['Month', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    const lstYear = [2022, 2023, 2024, 2025, 2026, 2027, 2028,
        2029, 2030, 2031, 2032, 2033, 2034, 2035, 2036,
        2037, 2038, 2039, 2040, 2041, 2042, 2043, 2044,
        2045, 2046, 2047, 2048, 2049, 2050];
    const [lstMonthlyTchSubsDuty, setLstMonthlyTchSubsDuty] = useState([])
    const [lstYearlyTchSubsDuty, setLstYearlyTchSubsDuty] = useState([])
    const [lstAcademicYear, setLstAcademicYear] = useState([]);
    const [acdYrId, setAcdYrId] = useState(localStorage.getItem('academicYearId') || 0);

    const getAcademicYearList = () => {
        setLoader("block");
        setOpacity(0.5);
        getAcademicYearListSvc(academicYearListResponse);
    }

    const academicYearListResponse = (data) => {
        var obj = data;
        if (obj.status === 'Success') {
            // console.log('obj', obj);
            setLstAcademicYear(obj.lstAcademicYear);
        }
        else {
            if (obj.message === 'You are not logged in') {
                toast(obj.message);
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            }
            else if (obj.message == 'Your Session is expired, login again') {
                toast(obj.message);
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        }
        setLoader("none");
        setOpacity(1);
    }


    useEffect(() => {
        getDailySubsDuty()
    }, []);

    const getDailySubsDuty = () => {
        const currentDate = new Date();
        let tDt = dtToDMY(currentDate);
        setToDt(tDt);
        const startDate = new Date(currentDate);
        // by default first date of the month
        startDate.setDate(1);
        let fDt = dtToDMY(startDate)
        setFromDt(fDt);
        if (fDt && tDt) {
            getSubstitutionDuties(fDt, tDt);
        }
    }
    useEffect(() => {
        console.log('useEffect():: activeTab', activeTab)
        if (activeTab == 'daily') {
            getDailySubsDuty()
        }
        if (activeTab == 'monthly') {
            getMonthlySubsDuty()
        }
        if (activeTab == 'yearly') {
            getAcademicYearList();
            getYearlySubsDuty();
        }
    }, [activeTab]);

    const getSubstitutionDuties = (stDt, endDt) => {
        setLoader("block");
        setOpacity(0.5);
        // Call the service to get the substitution duties
        getSubstitutionDutiesSvc(stDt, endDt, handleSubstitutionDutiesResponse);
    }
    const handleSubstitutionDutiesResponse = (data) => {
        setLoader("none");
        setOpacity(1);
        if (data.status === 'Success') {
            setLstTchSubsDuty(data.lstTchSubsDuty);;
        } else {
            handleServiceError(data.message || "Failed to fetch substitution duties");
        }
    };
    const getMonthlySubsDuty = () => {
        if (dt) {
            getMonthlySubstitutionDuties(dt)
        }
    }
    const getYearlySubsDuty = () => {
        if (acdYrId) {
            getYearlySubstitutionDuties(acdYrId)
        }
    }
    const getYearlySubstitutionDuties = (acdYrId) => {
        setLoader("block");
        setOpacity(0.5);
        getYearlySubstitutionDutiesSvc(acdYrId, handleYearlySubstitutionDutiesResponse);
    }

    const handleYearlySubstitutionDutiesResponse = (data) => {
        setLoader("none");
        setOpacity(1);

        console.log(data)
        if (data.status === 'Success') {
            setLstYearlyTchSubsDuty(data.lstTchSubsYearlySummary);;
        } else {
            handleServiceError(data.message || "Failed to fetch monthly substitution duties");
        }
    };
    const getMonthlySubstitutionDuties = (yyyyMm) => {
        setLoader("block");
        setOpacity(0.5);
        getMonthlySubstitutionDutiesSvc(yyyyMm, handleMonthlySubstitutionDutiesResponse);
    }

    const handleMonthlySubstitutionDutiesResponse = (data) => {
        setLoader("none");
        setOpacity(1);

        console.log(data)
        if (data.status === 'Success') {
            setLstMonthlyTchSubsDuty(data.lstTchSubsMonthlySummary);;
        } else {
            handleServiceError(data.message || "Failed to fetch monthly substitution duties");
        }
    };
    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const openSubstituionDetails = (tchId) => {
        setTchId(tchId);
        setFlgDutiesPopup(true);
        // Open the popup to show substitution details for the selected teacher
        // openSubstitutionDetailsPopup(tchId);
    }

    const closeSubstitutionDetailsPopup = () => {
        setFlgDutiesPopup(false);
        setTchId(0);
    }
    function handleMonthChange(param) {
        var m = lstMonth.indexOf(param)
        // console.log(m)
        setMonth(param)
        var dt = year * 100 + m
        // console.log(dt)
        setDt(dt)
        setMonthInt(m)
    }

    function handleYearChange(param) {
        var dt = param * 100 + monthInt
        // console.log(dt)
        setDt(dt)
        setYear(param)
    }

    const changeAcademicYear = (acdYrId) => {
        console.log("changeAcademicYear called with academicYearId", acdYrId);
        console.log(" lstAcademicYear", lstAcademicYear);
        if (acdYrId == 0) {
            toast.warn("please select Academic Year");
            return;
        }
        else {
            setLoader("block");
            setOpacity(0.5);
        }
    }

    return (
        <div >
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <div className="col-lg-6 col-md-6 col-sm-8 col-xs-12 col-centered padding-remove" style={{ marginTop: "20px" }}>
                <div className="col-sm-12 col-centered padding-remove">
                    <div style={{ padding: 20, display: 'flex', justifyContent: 'space-between' }}>

                        {/* Tab Buttons */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20, height: 120, marginRight: 20 }}>
                            <button
                                onClick={() => setActiveTab('daily')}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: activeTab === 'daily' ? '#007bff' : '#e0e0e0',
                                    color: activeTab === 'daily' ? '#fff' : '#000',
                                    border: 'none',
                                    cursor: 'pointer',
                                    width: 80,
                                }}>
                                Daily
                            </button>
                            <button
                                onClick={() => setActiveTab('monthly')}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: activeTab === 'monthly' ? '#007bff' : '#e0e0e0',
                                    color: activeTab === 'monthly' ? '#fff' : '#000',
                                    border: 'none',
                                    cursor: 'pointer',
                                    width: 80,
                                }}>
                                Monthly
                            </button>
                            <button
                                onClick={() => setActiveTab('yearly')}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: activeTab === 'yearly' ? '#007bff' : '#e0e0e0',
                                    color: activeTab === 'yearly' ? '#fff' : '#000',
                                    border: 'none',
                                    cursor: 'pointer',
                                    width: 80,
                                }}>
                                Yearly
                            </button>
                        </div>
                        <div
                            style={{
                                border: '1px solid #ccc',
                                padding: 20,
                                borderRadius: 5,
                            }}
                        >

                            {activeTab === 'daily' && (
                                <div>
                                    <div className="col-sm-4 padding-remove">
                                        <label className='col-sm-3 padding-remove'>From:</label>
                                        <div className="col-sm-8 padding-remove" style={{ position: "relative" }}>
                                            <DatePicker
                                                id="selDtFrom"
                                                className="form-control pr-4"
                                                placeholderText="From Date"
                                                selected={dmyToDate(fromDt)}
                                                onChange={(dt) => setFromDt(dtToDMY(dt))}
                                                dateFormat="dd-MM-yyyy"
                                                dropdownMode="select"
                                                autoComplete="off"
                                                showMonthDropdown
                                                showYearDropdown
                                                adjustDateOnChange
                                            />
                                            <span
                                                id="calendar1"
                                                title="calendar"
                                                className="glyphicon glyphicon-calendar"
                                                style={{
                                                    position: "absolute",
                                                    right: "10px",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    cursor: "pointer",
                                                    color: "#666",
                                                }}
                                                onClick={() => document.getElementById("selDtFrom").focus()}
                                            ></span>
                                        </div>

                                    </div>
                                    <div className="col-sm-4 padding-remove">
                                        <label className='col-sm-3 padding-remove'>To:</label>
                                        <div className="col-sm-8 padding-remove" style={{ position: "relative" }}>
                                            <DatePicker
                                                id="selDtTo"
                                                className="form-control pr-4"
                                                placeholderText="To Date"
                                                selected={dmyToDate(toDt)}
                                                onChange={(dt) => setToDt(dtToDMY(dt))}
                                                dateFormat="dd-MM-yyyy"
                                                dropdownMode="select"
                                                autoComplete="off"
                                                showMonthDropdown
                                                showYearDropdown
                                                adjustDateOnChange
                                            />
                                            <span
                                                id="calendar2"
                                                title="calendar"
                                                className="glyphicon glyphicon-calendar"
                                                style={{
                                                    position: "absolute",
                                                    right: "10px",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    cursor: "pointer",
                                                    color: "#666",
                                                }}
                                                onClick={() => document.getElementById("selDtTo").focus()}
                                            ></span>
                                        </div>
                                    </div>
                                    <div className="col-sm-4 padding-remove" style={{left:5}}>
                                        <div style={{ width: "100px" }}>
                                            <button
                                                type="button"
                                                style={{ width: "100%" }}
                                                className="btn btn-primary pull-right"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    getSubstitutionDuties(fromDt, toDt);
                                                }}>
                                                View
                                            </button>
                                        </div>
                                    </div>
                                </div>)}
                            {activeTab == "monthly" && <div>
                                <div className="col-sm-2 padding-remove">
                                    <select
                                        className="form-control "
                                        onChange={(e) => handleYearChange(e.target.value)}
                                        value={year}
                                    >
                                        <option value={""}>Year</option>

                                        {lstYear.map((year, idx) => {
                                            return (
                                                <option key={idx} value={year}>{year}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                                <div className="col-sm-2 padding-remove">
                                    <select
                                        className="form-control"
                                        onChange={(e) => handleMonthChange(e.target.value)}
                                        value={month}
                                    >
                                        {lstMonth.map((month, idx) => {
                                            return (
                                                <option key={idx} value={month}>{month}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                                <div className="col-sm-4  padding-remove">
                                    <div style={{ width: "100px" }}>
                                        <button
                                            type="button"
                                            style={{ width: "100%" }}
                                            className="btn btn-primary pull-right"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                getMonthlySubstitutionDuties(dt);
                                            }}>
                                            View
                                        </button>
                                    </div>
                                </div>
                            </div>}
                            {activeTab == 'yearly' &&
                                <div className="col-sm-2 padding-remove">
                                    <select
                                        className="col-sm-4 form-control wingSelect"
                                        style={{ marginBottom: 10 }}
                                        value={acdYrId}
                                        onChange={(e) => changeAcademicYear(e.target.value)}>
                                        <option value={0}>Academic Year</option>
                                        {lstAcademicYear &&
                                            lstAcademicYear.map((academicYear) => (
                                                <option
                                                    key={academicYear.academicYearId}
                                                    value={academicYear.academicYearId}>
                                                    {academicYear.academicYear}
                                                </option>
                                            ))
                                        }
                                    </select>
                                </div>}
                            <div className="col-sm-12 col-centered padding-remove" style={{ marginTop: "50px" }}>
                                {activeTab && <SubstitutionDutyTbl
                                    key={activeTab}
                                    activeTab={activeTab}
                                    lstTchSubsDuty={activeTab == 'daily' ? lstTchSubsDuty : (activeTab == 'monthly' ? lstMonthlyTchSubsDuty : (activeTab == 'yearly' ? lstYearlyTchSubsDuty: lstTchSubsDuty))}
                                    tchId={tchId}
                                    setTchId={setTchId}
                                    substitutionDt={substitutionDt}
                                    setSubstitutionDt={setSubstitutionDt}
                                    openSubstituionDetails={openSubstituionDetails}
                                />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default SubstitutionDutyCtrl;